<script lang="ts" setup>
import BaseTag from './BaseTag.vue';

defineProps<{
  serialNumber?: string;
}>();
</script>

<template>
  <BaseTag
    bg-sky-500
    :class="{ 'cursor-pointer': !!$attrs.onClick }"
  >
    {{ serialNumber }}
    <slot />
  </BaseTag>
</template>
